import { render, staticRenderFns } from "./CollectionListSearchTable.vue?vue&type=template&id=6059a14a&"
import script from "./CollectionListSearchTable.vue?vue&type=script&lang=ts&"
export * from "./CollectionListSearchTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports